import { getAsync } from '../../../../shared/api.service'
import { queryString } from '../../../../shared/sso-workspace/auth-api'
import { blobText, downloadCsvFile } from '../api-keys/sys-api'
import { endsIncomplete } from './consent-log-words'

// The website consent log's staff routes (content's
// /api/ddd/consent-log-sys/..., SYS_CONSENT_LOG read), called straight at
// REACT_APP_API_CONTENT with the staff session. Plain functions, each
// resolving to the response body and, on failure, throwing the response
// ({ status, data: { code, message } }), so serverMessage(err) reads the
// server's sentence and <ErrorReference error={err} /> its request id.
const PATH = 'api/ddd/consent-log-sys'

const unwrap = async call => {
  try {
    const result = await call()
    return result ? result.data : undefined
  } catch (err) {
    throw (err && err.response) || err
  }
}

// A consent ID's records, oldest first ([] for an ID nobody holds).
export const getRecords = consentId =>
  unwrap(() => getAsync(process.env.REACT_APP_API_CONTENT, `${PATH}/records/${encodeURIComponent(consentId)}`))

// { valid: boolean }: whether signature is the one we gave consentId.
export const verifySignature = (consentId, signature) =>
  unwrap(() => getAsync(process.env.REACT_APP_API_CONTENT, `${PATH}/verify${queryString({ consentId, signature })}`))

export const exportPath = ({ from, to }) => `${PATH}/export.csv${queryString({ from, to })}`

// How much of the file's end is read for the EXPORT INCOMPLETE line (a
// short line; a record line is a few KB at most).
const TAIL_BYTES = 64 * 1024

// The CSV of a range of days (UTC, YYYY-MM-DD; at most MAX_EXPORT_DAYS),
// downloaded with the session. Resolves to { incomplete }: whether the file
// ends with content's EXPORT INCOMPLETE line (a database error after the
// download began; the file is saved either way). Only its end is read.
export const downloadExport = async (range, filename) => {
  const blob = await downloadCsvFile(exportPath(range), filename)
  if (!blob || typeof blob.slice !== 'function') return { incomplete: false }
  const start = Math.max(0, blob.size - TAIL_BYTES)
  const tail = await blobText(start > 0 ? blob.slice(start) : blob)
  return { incomplete: endsIncomplete(tail, start > 0) }
}
